import { PaymentDetails } from 'constants/payment';
import { useBottomSheet } from 'hooks/bottomSheet';
import { useToast } from 'hooks/toast';
import React, { useEffect, useState } from 'react';
import { Clipboard } from 'react-native';
import { formatDateString } from 'services/date';
import { PriceFormat } from 'services/price';

import InvoiceImageSvg from '@assets/icons/invoice.svg';

import {
  Container,
  Content,
  Header,
  InvoiceImage,
  Title,
  Subtitle,
  InvoiceDescriptionItem,
  InvoiceDescriptionTitle,
  InvoiceDescriptionValue,
  Footer,
  FilledButton,
  TransparentButton,
  FilledButtonText,
  TransparentButtonText,
  BarCodeContainer,
  BarCode
} from './styles';

interface BoletoBottomSheetProps {
  data: PaymentDetails;
}

const BoletoBottomSheet: React.FC<BoletoBottomSheetProps> = ({ data }) => {
  const [boletoData, setBoletoData] = useState(data);
  const { closeBottomSheet } = useBottomSheet();
  const { addToast } = useToast();

  useEffect(() => {
    const updatedData: PaymentDetails = {
      ...data,
      maximumDueDate: formatDateString(data.maximumDueDate)
    };
    setBoletoData(updatedData);
  }, [data]);

  return (
    <Container>
      <Header>
        <InvoiceImage source={InvoiceImageSvg} />
        <Title>Pagamento de fatura</Title>
        <Subtitle>
          Para pagar sua fatura, basta copiar sua linha digitável abaixo
        </Subtitle>
      </Header>
      <Content>
        <InvoiceDescriptionItem border>
          <InvoiceDescriptionTitle>Vencimento em</InvoiceDescriptionTitle>
          <InvoiceDescriptionValue>
            {boletoData.maximumDueDate}
          </InvoiceDescriptionValue>
        </InvoiceDescriptionItem>
        <InvoiceDescriptionItem>
          <InvoiceDescriptionTitle>
            Valor para pagamento
          </InvoiceDescriptionTitle>
          <InvoiceDescriptionValue>
            R$ {PriceFormat(boletoData.value)}
          </InvoiceDescriptionValue>
        </InvoiceDescriptionItem>

        <BarCodeContainer>
          <BarCode>{boletoData.digitableLine}</BarCode>
        </BarCodeContainer>
      </Content>
      <Footer>
        <FilledButton>
          <FilledButtonText
            testID="filledButtonTextBoletoBottomSheet"
            onPress={() => {
              Clipboard.setString(boletoData.digitableLine);
              closeBottomSheet();
              addToast('Código para pagamentos copiado!');
            }}
          >
            Copiar código de barras
          </FilledButtonText>
        </FilledButton>
        <TransparentButton>
          <TransparentButtonText onPress={closeBottomSheet}>
            Voltar para minhas faturas
          </TransparentButtonText>
        </TransparentButton>
      </Footer>
    </Container>
  );
};

export default BoletoBottomSheet;
